import { ASSIGNABLE_DOCUMENT_TYPES } from '../types/documentTemplates.types';
import type { ProductSlot, TemplateAssignment } from '../types/templateAssignments.types';

export function buildProductSlots(assignments: readonly TemplateAssignment[]): ProductSlot[] {
  return ASSIGNABLE_DOCUMENT_TYPES.map((documentType) => ({
    documentType,
    assignment: assignments.find((item) => item.level === 'product' && item.documentType === documentType) ?? null,
  }));
}

export function dealerAssignmentRows(
  assignments: readonly TemplateAssignment[],
  dealerNames: ReadonlyMap<string, string>,
): TemplateAssignment[] {
  const nameOf = (assignment: TemplateAssignment): string => dealerNames.get(assignment.dealerId ?? '') ?? assignment.dealerId ?? '';
  const typeRank = (assignment: TemplateAssignment): number => ASSIGNABLE_DOCUMENT_TYPES.indexOf(assignment.documentType);

  return assignments
    .filter((item) => item.level === 'dealer')
    .sort((a, b) => nameOf(a).localeCompare(nameOf(b)) || typeRank(a) - typeRank(b));
}

export function dealerIdsOf(assignments: readonly TemplateAssignment[]): string[] {
  return assignments.flatMap((item) => [item.dealerId, item.template.ownerDealerId].filter((id): id is string => id !== null));
}
